import { render } from "./Footer.vue?vue&type=template&id=2ae52f56&scoped=true"
const script = {}

import "./Footer.scss?vue&type=style&index=0&id=2ae52f56&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae52f56"]])

export default __exports__